// src/features/auth/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { loadUserProfile } from './authThunks';
import { ACCESS_TOKEN } from "../../constants";

const authSlice = createSlice({
  name: 'auth',
  initialState: { 
    user: null,
    userId: null,
    accessToken: localStorage.getItem(ACCESS_TOKEN),
    //values: checking - authenticated - unauthenticated - failed
    status: localStorage.getItem(ACCESS_TOKEN) ? 'checking' : 'unauthenticated',
    error: null
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.userId = user?.id;
      state.accessToken = accessToken || localStorage.getItem(ACCESS_TOKEN);
      state.status = 'authenticated';
    },
    logOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.status = 'unauthenticated';
      state.error = null;
      state.userId = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.userId = action.payload?.id;
      state.status = action.payload ? 'authenticated' : 'unauthenticated';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserProfile.pending, (state) => {
        state.status = 'checking';
      })
      .addCase(loadUserProfile.fulfilled, (state, action) => {
        state.status = 'authenticated';
        state.user = action.payload;
        state.userId= action.payload.id;
      })
      .addCase(loadUserProfile.rejected, (state, action) => {
        state.status = 'unauthenticated';
        state.error = action.payload;
        state.accessToken = null; 
      });
  }
});

export const { setCredentials, logOut, setUser } = authSlice.actions;
export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentUserId = (state) => state.auth.userId;
export const selectCurrentToken = (state) => state.auth.accessToken;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
